module.exports = __webpack_public_path__ + "static/img/corenrTechnicalTwo.295979b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/corenrTechnicalTwo.png
// module id = ZyAh
// module chunks = 1